import { CascoPackage, CascoTerritoryType } from '@insurance/api/requests'
import { RadioCardGroup } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { Form } from 'antd'
import { useTranslation } from 'react-i18next'

import { useCascoInsuranceValues } from './CascoInsuranceContext'
import { formProps } from './utils'

export const Territory = () => {
  const { t } = useTranslation()
  const { territoryProps, insurancePackageProps } = formProps(t)
  const { required } = useValidationsField()
  const { isEditable } = useCascoInsuranceValues()
  const insurancePackage = Form.useWatch(insurancePackageProps.name, {
    preserve: true
  })

  if (insurancePackage === CascoPackage.MINI) return null

  const options = Object.values(CascoTerritoryType).map((value) => ({
    label: t(value),
    value
  }))

  return (
    <Form.Item {...territoryProps} rules={[required]}>
      <RadioCardGroup disabled={isEditable} options={options} />
    </Form.Item>
  )
}
